import { create } from "zustand";
import { notificationsApi } from "@api/modules/notifications.api";

interface NotificationState {
    unreadCount: number;
    setUnreadCount: (count: number) => void;
    fetchUnreadCount: () => Promise<void>;
}

export const useNotificationStore = create<NotificationState>((set) => ({
    unreadCount: 0,
    setUnreadCount: (count) => set({ unreadCount: Math.max(0, count) }),
    fetchUnreadCount: async () => {
        try {
            const count = await notificationsApi.unreadCount();
            set({ unreadCount: count });
        } catch {
            /* no-op — next poll/SSE event will retry */
        }
    },
}));
